import list from "./list";
import robList from "./robList";
import update from "./update";

export default {
  namespaced: true,
  modules: {
    list,
    robList,
    update,
  },
};
